import { handleAjaxError } from "./handleAjaxError";
import { renderMessage } from "./renderMessage";
import { scrollToChatBottom } from "./scrollToChatBottom";
import { appendUserMessage } from "./appendUserMessage";
import { updateCredits } from "./updateCredits";
const {
    createGenerationRequestId,
    waitForAsyncTextGeneration,
} = require("../helpers/asyncTextGeneration.cjs");

function requestGenerationStatus(job) {
    return new Promise((resolve, reject) => {
        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: "post",
            timeout: 15000,
            data: {
                action: growtype_chat_ajax.generation_job_status_action,
                job_id: job.id,
                job_token: job.token,
                nonce: growtype_chat_ajax.nonce,
            },
            success: resolve,
            error: reject,
        });
    });
}

/**
 * Uses event delegation so it works for messages loaded dynamically.
 */
export function regenerateMessage(action) {
    syncRetryAvailability(action);
    window.setTimeout(function () {
        // Dynamically rendered messages are initialized before they are attached
        // to the chat form. Re-sync once the current render task has appended them.
        syncRetryAvailability(action);
    }, 0);

    // Guard: only register the document listener once
    if (window._regenerateMessageBound) {
        return;
    }
    window._regenerateMessageBound = true;

    $(document).on('click', '.g-chatform-message-regenerate', function (event) {
        event.preventDefault();
        event.stopPropagation();

        let submitBtn = $(this);
        let chatForm = submitBtn.closest('.g-chatform');
        let sessionToken = chatForm.attr('data-session-token');
        let messageElement = submitBtn.closest('.g-chatform-message');
        let messageId = messageElement.attr('data-id');
        let messageRole = messageElement.attr('data-role');

        if (!messageId || submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
            return;
        }

        submitBtn.addClass('is-loading');
        const generationRequestId = submitBtn.data('generation-request-id') || createGenerationRequestId();
        submitBtn.data('generation-request-id', generationRequestId);

        // Show thinking loader right away
        let userMessageTemplate = appendUserMessage(chatForm, 'text');
        userMessageTemplate.show();
        scrollToChatBottom(500, true);

        // Hide the actions menu
        $('.g-chatform-message-actions-options').fadeOut(200);

        const data = {
                token: sessionToken,
                action: growtype_chat_ajax.regenerate_message_action,
                message_id: messageId,
                nonce: growtype_chat_ajax.nonce,
                generation_request_id: generationRequestId,
            };

            // Pick up any feedback stashed by regenerateWithFeedbackMessage
            const pendingFeedback = messageElement.data('pending_feedback');
            if (pendingFeedback) {
                data.feedback_text = pendingFeedback;
                messageElement.removeData('pending_feedback');
            }

        jQuery.ajax({
            url: growtype_chat_ajax.url,
            type: 'post',
            data: data,
            success: async function (response) {
                try {
                    response = await waitForAsyncTextGeneration(response, {
                        requestStatus: requestGenerationStatus,
                    });
                } catch (error) {
                    userMessageTemplate.remove();
                    submitBtn.removeClass('is-loading');
                    handleAjaxError(error, submitBtn);
                    return;
                }
                submitBtn.removeClass('is-loading');

                if (response.success) {
                    submitBtn.removeData('generation-request-id');
                    updateCredits(response.data.existing_credits);
                    // Stored and visible history is preserved until the replacement
                    // response has succeeded. Remove only the superseded response.
                    if (response.data && response.data.response_messages) {
                        if (messageRole === 'admin') {
                            messageElement
                                .nextAll('.g-chatform-message')
                                .not(userMessageTemplate)
                                .remove();
                        } else {
                            const latestHumanMessage = messageElement
                                .prevAll('.g-chatform-message[data-role="admin"]')
                                .first();

                            if (latestHumanMessage.length) {
                                latestHumanMessage
                                    .nextAll('.g-chatform-message')
                                    .not(userMessageTemplate)
                                    .remove();
                            } else {
                                messageElement.remove();
                            }
                        }

                        renderMessage(chatForm, response, userMessageTemplate).then(() => {
                            // After rendering, update the data-id on the last admin message
                            // so that a subsequent retry sends the correct new message ID.
                            const newAdminMsgId = response.data.last_ai_message_id;
                            if (newAdminMsgId) {
                                const lastAdminMsg = chatForm.find('.g-chatform-message[data-role="admin"]').last();
                                if (lastAdminMsg.length) {
                                    lastAdminMsg.attr('data-id', newAdminMsgId);
                                }
                            }
                            syncRetryAvailability(chatForm);
                            scrollToChatBottom(500, true);
                        });
                    } else {
                        userMessageTemplate.remove();
                    }
                } else {
                    submitBtn.removeData('generation-request-id');
                    userMessageTemplate.remove();
                    handleAjaxError(response, submitBtn);
                }
            },
            error: function (response) {
                userMessageTemplate.remove();
                submitBtn.removeClass('is-loading');
                handleAjaxError(response, submitBtn);
                if (Number(response.status || 0) >= 400 && Number(response.status || 0) < 500) {
                    submitBtn.removeData('generation-request-id');
                }
            }
        });
    });
}

function syncRetryAvailability(scope) {
    const source = $(scope || document);
    const roots = source.hasClass('g-chatform')
        ? source
        : source.closest('.g-chatform').add(source.find('.g-chatform'));

    roots.each(function () {
        const chatForm = $(this);
        const persistedMessages = chatForm.find('.g-chatform-message').filter(function () {
            return String($(this).attr('data-id') || '').trim() !== '';
        });
        const retryButtons = persistedMessages.find('.g-chatform-message-regenerate');

        // Retrying an older item safely starts a new continuation from that
        // turn. The server preserves the current branch until the replacement
        // has been generated and persisted, so every saved message can expose
        // the same Retry action.
        retryButtons.removeClass('d-none is-disabled');
    });
}
